<template>
  <footer class="py-16 mt-auto bg-stone-50 border-t border-gray-200">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
        <!-- Brand -->
        <div>
          <h3 class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">{{ $t('footer.brand') }}</h3>
          <p class="text-gray-600 text-sm leading-relaxed">
            {{ $t('footer.description') }}
          </p>
          <nav class="mt-5 flex flex-col items-start gap-2 text-sm">
            <router-link
              to="/privacy-policy"
              class="text-gray-900 hover:text-gray-600 transition-colors"
            >
              {{ $t('footer.privacy_policy') }}
            </router-link>
            <router-link
              to="/terms-of-use"
              class="text-gray-900 hover:text-gray-600 transition-colors"
            >
              {{ $t('footer.terms_of_use') }}
            </router-link>
            <button
              type="button"
              class="text-left text-gray-900 hover:text-gray-600 transition-colors"
              @click="openSettings"
            >
              {{ $t('cookie_consent.manage') }}
            </button>
          </nav>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">{{ $t('footer.contact') }}</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>{{ $t('footer.address') }}</li>
            <li>{{ $t('footer.tel') }}: <a href="tel:+66830131218" class="text-gray-900 hover:text-gray-600 transition-colors">(+66) 83 013 1218</a></li>
            <li>{{ $t('footer.tel') }}: <a href="tel:+66924988850" class="text-gray-900 hover:text-gray-600 transition-colors">(+66) 92 498 8850</a></li>
            <li><a href="https://lin.ee/QpmIqtS" target="_blank" class="text-gray-900 hover:text-gray-600 transition-colors">{{ $t('footer.line') }}: @achirayastudio</a></li>
            <li>WhatsApp: <a href="https://wa.me/66952705676" target="_blank" class="text-gray-900 hover:text-gray-600 transition-colors">+66952705676</a></li>
            <li>{{ $t('footer.email') }}: <a href="mailto:support@jackachihouse.com" class="text-gray-900 hover:text-gray-600 transition-colors">support@jackachihouse.com</a></li>
          </ul>
        </div>

        <!-- Hours -->
        <div>
          <h4 class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">{{ $t('footer.hours') }}</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>{{ $t('footer.daily_hours') }}</li>
            <li class="text-xs text-gray-500">{{ $t('footer.holiday_note') }}</li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-200 mt-12 pt-8 text-center">
        <p class="text-xs text-gray-500 uppercase tracking-wider">{{ $t('footer.copyright', { year: new Date().getFullYear() }) }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useCookieConsent } from '@/composables/useCookieConsent'

const { openSettings } = useCookieConsent()
</script>
